// extracted by mini-css-extract-plugin
export default {"pageContainer":"ForgotPassword_pageContainer__X1qaS","formPageContainer":"ForgotPassword_formPageContainer__VB8+B","formContainer":"ForgotPassword_formContainer__jTc7q"};